// /frontend/src/Pages/Employer/Dashboard.jsx
import React from "react";
import EmployerHome from "./Home";

const EmployerDashboard = () => {
  return <EmployerHome />;
};

export default EmployerDashboard;
